import { Theme, makeStyles } from "@material-ui/core";
import { headerHeight, headerHeightMobile, headerHeightMobileXs } from "../../../constants";
import { contactFooterHeightDesktop, contactFooterHeightMobile } from "./Onboarding";

export const useOnboardingStyles = makeStyles((theme: Theme) => ({
	root: {
		flexGrow: 1,
		marginTop: headerHeight,
		[theme.breakpoints.down("sm")]: {
			marginTop: headerHeightMobile,
		},
		[theme.breakpoints.down("xs")]: {
			marginTop: headerHeightMobileXs
		}
	},
	formWrapper: {
		width: "100%",
	},
	errorMessage: {
		marginBottom: "8px",
	},
	contentAndFooterParent: {
		position: "relative",
		paddingBottom: contactFooterHeightDesktop,
		minHeight: "100vh",
		[theme.breakpoints.down("sm")]: {
			paddingBottom: contactFooterHeightMobile,
		}
	},
	footerWrapper: {
		position: "absolute",
		bottom: 0,
		width: "100%"
	},
	navigationButton: {
		borderRadius: 10,
		padding: "8px 22px",
		fontSize: 14,
		margin: "32px 0px",
		height: 56,
		[theme.breakpoints.down("sm")]: {
			margin: "16px 0px",
			height: 48,
		},
	},
	fieldLabel: {
		color: theme.palette.text.primary
	},
	/* KYC-page: */
	contactWrapper: {
		borderTop: "1px solid #999",
		backgroundColor: "#e9e9e9",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		[theme.breakpoints.up("md")]: {
			height: 90
		},
	},
	contactTitle: {
		fontWeight: "bold",
	},
	contactData: {
		padding: "24px 4% 24px 4%",
		[theme.breakpoints.up("md")]: {
			borderLeft: "2px solid #999",
			"&:last-child": {
				borderRight: "2px solid #999"
			},
		},
		[theme.breakpoints.down("sm")]: {
			padding: "16px 20px 16px 20px"
		},
		[theme.breakpoints.down("xs")]: {
			padding: "12px 24px 12px 24px"
		}
	}
}));
